import { Controller } from '@hotwired/stimulus';
import { createConsumer } from '@rails/actioncable';

export default class extends Controller {
  static targets = ['reportsTable'];

  connect() {
    this.subscription = createConsumer().subscriptions.create(
      { channel: 'ReportsChannel' },
      {
        received: (data) => {
          if (data.status === 'processing') {
            this.addPendingRow(data);
          } else if (data.status === 'completed') {
            this.updateCompletedRow(data);
          }
        },
      },
    );
  }

  disconnect() {
    this.subscription.unsubscribe();
  }

  addPendingRow(data) {
    if (document.getElementById(`report-${data.report_id}`)) return;

    const row = `
      <tr id="report-${data.report_id}">
        <td>${data.created_at}</td>
        <td>${data.report_name}</td>
        <td>Pending</td>
      </tr>
    `;
    this.reportsTableTarget.insertAdjacentHTML('afterbegin', row);

    if (data.status === 'completed') {
      this.updateCompletedRow(data);
    }
  }

  updateCompletedRow(data) {
    const row = document.getElementById(`report-${data.report_id}`);

    if (row) {
      row.cells[2].innerHTML = `<a href="${data.download_url}">${data.file_name}</a>`;
    } else {
      this.addPendingRow(data);
    }
  }
}
